export default __webpack_public_path__ + "static/media/hites_payku.207b904e.webp";